import { toError } from "@clipboard-health/util-ts";
import { useEffect } from "react";

import {
  addAppStateChangeListener,
  type AppListenerHandle,
} from "@src/appV2/NativeAdapters/app.adapter";
import { APP_V2_APP_EVENTS, logError, logEvent } from "@src/appV2/lib/analytics";
import { Platform } from "@src/mobile/utils/platform";

export function useInitializeMobileAppStateAnalytics() {
  useEffect(() => {
    if (!Platform.isMobile) {
      return undefined;
    }

    let listenerHandle: AppListenerHandle | undefined;
    let disposed = false;

    void addAppStateChangeListener(({ isActive }) => {
      logEvent(APP_V2_APP_EVENTS.APP_STATE_CHANGE, { isActive });
    })
      .then((handle) => {
        if (disposed) {
          void handle.remove();
          return;
        }

        listenerHandle = handle;
      })
      .catch((maybeError: unknown) => {
        logError(APP_V2_APP_EVENTS.APP_STATE_LISTENER_FAILURE, {
          error: toError(maybeError),
        });
      });

    return () => {
      disposed = true;
      void listenerHandle?.remove();
    };
  }, []);
}
